import { navigate } from 'gatsby'
import { sanitizeTrailingSlash } from '@utils'

export const handleNavigate = (link) =>
  link && link.slice(0, 1) === '/'
    ? navigate(sanitizeTrailingSlash(link))
    : link && navigate(link)
